// src/features/dashboard/components/StatGrid.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { StatCard } from './StatCard';
import { StatCardConfig } from '../types';

interface StatGridProps {
  statCards: StatCardConfig[];
  loading?: boolean;
}

// Grid container for stat cards
export const StatGrid = React.memo<StatGridProps>(({ statCards, loading = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.05 }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      {loading ? (
        Array.from({ length: 6 }).map((_, index) => (
          <StatCard
            key={index}
            index={index}
            loading={true}
            // Passing dummy data for other props
            title=""
            value={0}
            subtitle=""
            icon={() => null}
            bgColor=""
            textColor=""
            onClick={() => {}}
          />
        ))
      ) : (
        statCards.map((stat, index) => (
          <StatCard
            key={stat.title}
            title={stat.title}
            value={stat.value}
            subtitle={stat.subtitle}
            icon={stat.icon}
            bgColor={stat.bgColor}
            textColor={stat.textColor}
            onClick={stat.onClick}
            index={index}
          />
        ))
      )}
    </motion.div>
  );
});

StatGrid.displayName = 'StatGrid';
